<template>
    <!-- 星级评分 -->
    <div @click="setEditIndex(index)">
		<p v-if="isBankViewTest" class="my-bank-tag">{{$t('main.StarRating')}}</p>
        <el-row :gutter="10" class="question-box">
            <el-col v-if="!isBankViewTest" :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">
                {{ question.quesIndex + 1 }}
            </el-col>
            <el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" class="item_container_title"
                @click="setActiveInput(question.qid)">
                
                <span style="lineHeight: 30px" v-if="isBankViewTest && question.questionsName">{{question.questionsName}}</span>
				<TitleEditor 
                    :isTest="true"
					v-if="!isBankViewTest" 
					class="outline-none" 
					:qid="question.qid" 
					:class="question.qid"  
					:value="question.questionsName" 
                    :actionTitleEditorShow="activeInputId === question.qid"
					@childValueChange="val=>{ question.questionsName = val }" 
				></TitleEditor>
            </el-col>
			<el-col class="setBtn-box" :xs="7" :sm="7" :md="7" :lg="7" :xl="7" v-if="!$route.query.index">
				<OperateWrap
					style="display: flex;
						width: 100%;
						justify-content: end;
					"
					:bankId="$route.query.bankId"	
					:question="question"
				></OperateWrap>
			</el-col>
        </el-row>
        <el-row :gutter="10" style="margin-top: 12px !important;">
            <div >
                <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16"
                        class="el_item_option item_container_title" style="margin-left:50px">
                    <div class="inputvalue">
                        <ul class="ul_rate" >
                            <li v-for="(n,index) in (question.highestScore - question.lowestScore + 1)" :key="index" @click="selected($t('main.score'),n)">
                                <img v-show="cur<n && question.scoreImg == 'star'"  :src="rateDataList[0].checkedImg" alt="">
                                <img v-show="cur>=n && question.scoreImg == 'star'"  :src="rateDataList[0].checkedImg" alt="">
                                <img v-show="cur<n && question.scoreImg == 'heart'"  :src="rateDataList[1].checkedImg" alt="">
                                <img v-show="cur>=n && question.scoreImg == 'heart'"  :src="rateDataList[1].checkedImg" alt="">
                                <img v-show="cur<n && question.scoreImg == 'smile'"  :src="rateDataList[2].checkedImg" alt="">
                                <img v-show="cur>=n && question.scoreImg == 'smile'"  :src="rateDataList[2].checkedImg" alt="">
                                <img v-show="cur<n && question.scoreImg == 'thumb'"  :src="rateDataList[3].checkedImg" alt="">
                                <img v-show="cur>=n && question.scoreImg == 'thumb'"  :src="rateDataList[3].checkedImg" alt="">
                            </li>
                        </ul>
                        <div class="tips" >
                            <span  v-if="question.leftPromptText != ''">{{ question.leftPromptText }}</span>
                            <span  v-if="question.centerPromptText != ''">{{ question.centerPromptText }}</span>
                            <span  v-if="question.rightPromptText != ''">{{ question.rightPromptText }}</span>
                        </div>
                    </div>
                </el-col>
            </div>
        </el-row>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import OperateWrap from "./collectToBank/operateaWrap.vue"
import TitleEditor from "@/components/titleEditor/titleEditor.vue"
    export default {
	components: {
    	TitleEditor,
		OperateWrap
	},
    data() {
        return {
            select:true,
            cur:-1,
            imgIndex:0,
            rateDataList: [ 
                { 
                    bgImg: require('@/assets/rate/stars.png'),
                    checkedImg:require('@/assets/rate/star_def.png'),
                    unCheckedImg: require('@/assets/rate/star_sel.png'), 
                    value: 'star'
                },
                { 
                    bgImg: require('@/assets/rate/heart.png'),
                    checkedImg:require('@/assets/rate/heart_def.png'),
                    unCheckedImg: require('@/assets/rate/heart_sel.png'),
                    value: 'heart'
                },
                { 
                    bgImg: require('@/assets/rate/smile.png'),
                    checkedImg:require('@/assets/rate/laugh_def.png'),
                    unCheckedImg: require('@/assets/rate/laugh_sel.png'),
                    value: 'smile'
                },
                { 
                    bgImg: require('@/assets/rate/good.png'),
                    checkedImg:require('@/assets/rate/good_def.png'),
                    unCheckedImg: require('@/assets/rate/good_sel.png'),
                    value: 'thumb'
                },
            ],
        }
    },
    props: {
        question: {},
        editOptionIndex: {type:String,default:"0_0"},
        editIndex: {type:Number,default:0},
        isExistPage: {type:Boolean,default:false},
        index: {type:Number,default:0},
        tipsObj: {type: Object},
        imageUrl:{type:Object},
        // 管理题库时查看试题 只可以删除
        isBankViewTest: {
            type: Boolean,
            default: false
        },
    },        
    computed: {
        ...mapState(['activeInputId']),
    },
    methods: {
        ...mapActions(['setActiveInput']),
        selected(msg,n){
            this.cur = n;
            console.log(msg,n)
        },
        setEditIndex(index){
            this.$emit("setEditIndex",index);
        },
    },
    created() {
    //    console.log(this.question)
    //    console.log(this.question.scoreImg)
    }
}
</script>

<style scoped>
    .ul_rate {
        display:flex;
        justify-content: space-between;
    }
.item .el-badge__content.is-fixed{top:10px;}
.item.drag-handle{
  cursor: move;
}
    .inputvalue .tips{
        height: 30px;
        padding-top: 5px;
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        color: #aaaaaa;
    }
    .el-icon-common {
        margin-right: 23px;
        font-size: 16px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }
    .el-icon-common-option {
        margin-left: 10px;
        font-size: 22px !important;
        line-height: 40px !important;
        color: cornflowerblue;
        cursor: pointer;
    }
    .askxh {
        line-height: 40px;
        text-align: right;
    }
    .item_container_title {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }
</style>
